module.exports = __webpack_public_path__ + "static/media/moons_advanced-1500.fcd616be.webp";